import React from "react";
import UserSubmissionsTable from "./UserSubmissionsTable";

const ContactSubmissionsEditor = () => {
  return (
    <div className="container py-4">
      <h2 className="mb-4">Contact us — submissions</h2>
      <UserSubmissionsTable variant="contact" />
    </div>
  );
};

export default ContactSubmissionsEditor;
